export enum RoyaltyReceiver {
  OrdnanceSurvey = 0,
}
